/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_Aromas_DescriptionInputs */

const en_manage_aromas_description = /** @type {(inputs: Manage_Aromas_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add, edit, or remove aroma notes.`)
};

const es_manage_aromas_description = /** @type {(inputs: Manage_Aromas_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega, edita o elimina notas de aroma.`)
};

/**
* | output |
* | --- |
* | "Add, edit, or remove aroma notes." |
*
* @param {Manage_Aromas_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_aromas_description = /** @type {((inputs?: Manage_Aromas_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_Aromas_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_aromas_description(inputs)
	return es_manage_aromas_description(inputs)
});